import $ from "jquery";
import slick from "slick-carousel";

const partners = () => {
    //Главная страница - слайдер партнеров
    if ($(".partners").length) {
        $(".partners .slider").slick({
            slidesToShow: 4,
            dots: false,
            prevArrow:
                '<button type="button" class="slider__prev"><svg><use xlink:href="img/icons/sprite.svg#chevron"></use></svg></button>',
            nextArrow:
                '<button type="button" class="slider__next"><svg><use xlink:href="img/icons/sprite.svg#chevron"></use></svg></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    },
                },
            ],
        });
    }
};

export default partners;
